 <section style="background: #eee;padding: 5px;height: 400px;">
   <div class="btn-wrapper">
     <button class="btn-sm" [ngClass]="{'btn-primary':activeInvSection=='DT',
         'btn-default':activeInvSection!='DT'}" (click)="setInvestmentSection('DT')">{{'DETAILS' | dictionary}}
   </button>
     <button class="btn-sm"  style="margin: 0 5px;" [ngClass]="{'btn-primary':activeInvSection=='TR',
         'btn-default':activeInvSection!='TR'}" (click)="setInvestmentSection('TR')">{{'TRANSACTION' | dictionary}}
     </button>
     <button class="btn-sm" style="margin: 0 5px;" [ngClass]="{'btn-primary':activeInvSection=='DST',
         'btn-default':activeInvSection!='DST'}" (click)="setInvestmentSection('DST')">{{'DISTRIBUTION' | dictionary}}
     </button>

   </div>
   <div>

     <div class="col-lg-12" *ngIf="activeInvSection=='TR'">
       <div style="height: 35px;margin-bottom: 5px;border-bottom: 1px solid;">
         <label style="font-weight: 600;float: left;margin-top: 5px; margin-right: 5px;">{{'TRANSACTION_TYPE' | dictionary}}</label>
         <select [(ngModel)]="transSelTransType" (change)="filterChangeTrans()" class="form-control"
                 style="width: 150px;float: left;">
           <option *ngFor="let trType of transactionTypeList" [value]="trType.Key">{{trType.Title}}</option>
         </select>
         &nbsp;&nbsp; &nbsp;&nbsp;
         <label style="font-weight: 600;float: left;margin-left: 15px;margin-top: 5px;">{{'SELECT_YEAR' | dictionary}}
           &nbsp;&nbsp;</label>
         <select [(ngModel)]="transSelYear" (change)="filterChangeTrans()" style="width: 100px; float:left;"
                 class="form-control">
           <option *ngFor="let year of years" [value]="year.Year">{{year.Title}}</option>
         </select>
       </div>
       <kendo-grid #kendoGridComponent
                   [data]="transactionData"
                   [loading]="loading"
                   [height]="280"
                   [sortable]="configTransaction.sortable"
                   [sort]="sortTrans"
                   [selectable]="configTransaction.selectable"
                   (sortChange)="sortChangeTrans($event)"
                   (scrollBottom)="loadMoreTrans($event)">

         <kendo-grid-column *ngFor="let c of configTransaction.columns" [headerClass]="'gridheader text-color-1'" field="{{c.field}}"
                            [width]="c.width" title="{{c.title}}" [sortable]="c.sortable" [headerStyle]="{'text-align': c.align || 'left'}" [style]="{'text-align': c.align || 'left'}">
           <ng-template kendoGridCellTemplate let-dataItem>
             <span *ngIf="!c.formatPattern && !c.dateFormat && !c.applyMask">{{dataItem[c.field]}}</span>
             <app-secure-mask *ngIf="!c.formatPattern && !c.dateFormat && c.applyMask" [value]="dataItem[c.field]"></app-secure-mask>
             <FormatLabel [class.red]="dataItem[c.field] < 0" *ngIf="c.formatPattern && !c.dateFormat && !c.applyMask" [Text]="dataItem[c.field]"
                          [FormatPattern]="c.formatPattern"></FormatLabel>
             <div *ngIf="c.dateFormat && !c.formatPattern && !c.applyMask" >{{ dataItem[c.field] | date: c.dateFormat }}</div>
           </ng-template>
         </kendo-grid-column>
       </kendo-grid>
     </div>

     <div class="col-lg-12" *ngIf="activeInvSection=='DST'">

       <div class="table-toolbar">
         <div class="left-block">

           <label
             style="font-weight: 600;float: left;margin-top: 5px;">{{'PAYMENT_TYPE' | dictionary}}&nbsp;&nbsp;</label>
           <select [(ngModel)]="distributionType" (change)="filterChangeDistribution()" class="form-control"
                   style="width: 150px;float: left;">
             <option *ngFor="let diType of distributionTypeList" [value]="diType.Key">{{diType.Title}}</option>
           </select>
           &nbsp;&nbsp; &nbsp;&nbsp;
           <label style="font-weight: 600;float: left;margin-left: 15px;margin-top: 5px;">{{'SELECT_YEAR' | dictionary}}
             &nbsp;&nbsp;</label>
           <select [(ngModel)]="distSelYear" (change)="filterChangeDistribution()" style="width: 100px; float:left;"
                   class="form-control">
             <option *ngFor="let year of years" [value]="year.Year">{{year.Title}}</option>
           </select>
         </div>

         <div class="right-block">
           <div class="flex-row space-between">
             <span class="title">{{'YEAR_TO_DATE_DISTRIBUTIONS' | dictionary}}:</span>
             <label class="margin-0">
               <FormatLabel [Text]="destYTDDistribution" class="FieldContent"
                            FormatPattern="$##,###,###.##"></FormatLabel>
             </label>
           </div>
           <div class="flex-row space-between">
             <span class="title">{{'TOTAL_DISTRIBUTIONS' | dictionary}}:</span>
             <label class="margin-0">
               <FormatLabel [Text]="destTotalDistribution" class="FieldContent"
                            FormatPattern="$##,###,###.##"></FormatLabel>
             </label>
           </div>

           <div class="flex-row space-between" *ngIf="destTotalRedemption !== 0" >
             <span class="title">{{'YEAR_TO_DATE_REDEMPTION' | dictionary}}:</span>
             <label class="margin-0">
               <FormatLabel [Text]="destYTDRedemption" class="FieldContent"
                            FormatPattern="$##,###,###.##"></FormatLabel>
             </label>
           </div>

           <div class="flex-row space-between" *ngIf="destTotalRedemption !== 0" >
             <span class="title">{{'TOTAL_REDEMPTION' | dictionary}}:</span>
             <label class="margin-0">
               <FormatLabel [Text]="destTotalRedemption" class="FieldContent"
                            FormatPattern="$##,###,###.##"></FormatLabel>
             </label>
           </div>
         </div>
       </div>


       <kendo-grid #kendoGridComponent
                   [data]="distributionsData"
                   [loading]="loading"
                   [height]="280"
                   [sortable]="configDistribution.sortable"
                   [sort]="sortDist"
                   [selectable]="configDistribution.selectable"
                   (sortChange)="sortChangeDist($event)"
                   (scrollBottom)="loadMoreDist($event)">


         <kendo-grid-column *ngFor="let c of configDistribution.columns" [headerClass]="'gridheader text-color-1'" field="{{c.field}}"
                            [headerStyle]="{'text-align': c.align || 'left'}" [style]="{'text-align': c.align || 'left'}"
                            [width]="c.width" title="{{c.title}}" [sortable]="c.sortable">
           <ng-template kendoGridCellTemplate let-dataItem>
             <app-secure-mask *ngIf="!c.formatPattern && !c.dateFormat && c.applyMask" [value]="dataItem[c.field]"></app-secure-mask>

             <span *ngIf="!c.formatPattern && !c.dateFormat && !c.applyMask"
                   [ngClass]="c.class"
             >{{dataItem[c.field]}}</span>
             <FormatLabel  [class.red]="dataItem[c.field] < 0" *ngIf="c.formatPattern && !c.dateFormat && !c.applyMask" [Text]="dataItem[c.field]"
                          [ngClass]="c.class"
                          (click)="doAction($event, c.action, dataItem)"
                          [FormatPattern]="c.formatPattern"></FormatLabel>
             <div *ngIf="c.dateFormat && !c.formatPattern && !c.applyMask" >{{ dataItem[c.field] | date: c.dateFormat }}</div>
           </ng-template>
         </kendo-grid-column>
       </kendo-grid>
     </div>

     <div class="col-lg-12" *ngIf="activeInvSection=='DT'">
       <div class="info-row">
         <div class="info-row-inner-block"
              style="border: 1px solid;border-radius: 10px;padding: 5px;background: #fff; margin-right: 10px">
           <h4 style="text-align: center;text-decoration: underline;">{{'INVESTOR_INFO' | dictionary}}</h4>
           <div>
             <label class="investor-detail-label">{{'NAME' | dictionary}}:</label>{{investorBkrInfo.INVESTOR_NAME}}
           </div>
           <div>
             <label class="investor-detail-label">{{'ADDRESS' | dictionary}}:</label>
             {{investorBkrInfo.CURR_INVESTOR_ADDR_1}}
           </div>
           <div *ngIf="investorBkrInfo.CURR_INVESTOR_ADDR_2">
             <label class="investor-detail-label">&nbsp;</label>
             {{investorBkrInfo.CURR_INVESTOR_ADDR_2}}
           </div>
           <div>
             <label class="investor-detail-label">&nbsp;</label>
             {{investorBkrInfo.CURR_INVESTOR_CITY}},
             {{investorBkrInfo.CURR_INVESTOR_STATE}},
             {{investorBkrInfo.CURR_INVESTOR_ZIP_CODE}},
             {{investorBkrInfo.CURR_INVESTOR_COUNTRY}}
           </div>
           <div>
             <label class="investor-detail-label">{{'PHONE' | dictionary}}:</label>
             {{investorBkrInfo.CURR_INVESTOR_PHONE}}
           </div>
           <div>
             <label class="investor-detail-label">{{'EMAIL' | dictionary}}:</label>{{investorBkrInfo.INVESTOR_EMAIL}}
           </div>
           <div>
             <label class="investor-detail-label">{{'OWNERSHIP' | dictionary}}
               :</label>{{investorBkrInfo.OWNERSHIP_TYPE_DESC}}
           </div>
         </div>

         <div class="info-row-inner-block" style="border: 1px solid;border-radius: 10px;padding:5px;background: #fff;">
           <h4 style="text-align: center;text-decoration: underline;">{{'BROKER_INFO' | dictionary}}</h4>
           <div>
             <label class="investor-detail-label">{{'BROKER' | dictionary}}:</label>{{investorBkrInfo.CURR_BKR_NAME}}
           </div>
           <div>
             <label class="investor-detail-label">{{'REP' | dictionary}}:</label>
             {{investorBkrInfo.CURR_REP_NAME}}
           </div>
           <div *ngIf="investorBkrInfo.CURR_OFF_ADDR_1">
             <label class="investor-detail-label">&nbsp;</label>
             {{investorBkrInfo.CURR_OFF_ADDR_1}}
           </div>
           <div *ngIf="investorBkrInfo.CURR_OFF_ADDR_2">
             <label class="investor-detail-label">&nbsp;</label>
             {{investorBkrInfo.CURR_OFF_ADDR_2}}
           </div>
           <div *ngIf="investorBkrInfo.CURR_OFF_CITY_STATE_ZIP">
             <label class="investor-detail-label">&nbsp;</label>
             {{investorBkrInfo.CURR_OFF_CITY_STATE_ZIP}}
           </div>
           <div>
             <label class="investor-detail-label">{{'PHONE' | dictionary}}:</label>
             {{investorBkrInfo.CURR_REP_PHONE}}
           </div>
           <div>
             <label class="investor-detail-label">{{"EMAIL" | dictionary}}:</label>
             {{investorBkrInfo.CURR_EMAIL}}
           </div>
         </div>
       </div>


       <div style="margin-top: 10px; width: 50%">
         <div class="payee-inner-wrapper">
           <h4 style="text-align: center; text-decoration: underline;">{{'PAYEE_INFO' | dictionary}}</h4>
           <div class="mb-1">{{investment.PRIMARY_PYEE_LINE_1}}</div>
           <div class="mb-1">{{investment.PRIMARY_PYEE_LINE_2}}</div>
           <div class="mb-1" *ngIf="investment.PRIMARY_PYEE_LINE_1 !== 'WIRE' && investment.PRIMARY_PYEE_LINE_1 !== 'ACH'">{{investment.PRIMARY_PYEE_LINE_3}}</div>
           <app-secure-mask class="mb-1" *ngIf="investment.PRIMARY_PYEE_LINE_1 === 'WIRE' || investment.PRIMARY_PYEE_LINE_1 === 'ACH'" [value]="investment.PRIMARY_PYEE_LINE_3"></app-secure-mask>
           <div class="mb-1">{{investment.PRIMARY_PYEE_LINE_4}}</div>
           <div class="mb-1">{{investment.PRIMARY_PYEE_LINE_5}}</div>
           <div class="mb-1">{{investment.PRIMARY_PYEE_LINE_6}}</div>

         </div>
       </div>

     </div>
   </div>

 </section>

 <app-pop-up-dialog [Header]="'Paid to:'" [Message]="popupMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
